<template>
  <RCard class="additional-invoices">
    <CreateInvoiceModal
      :showing="showModal"
      :entity="{ id: $route.params.id }"
      :namespace="namespace"
      @refresh="getAndSetTableRows"
      @close="showModal = false"
    />

    <AgGrid ref="agGrid" :options="gridOptions" :row-data="data" @cell-value-changed="cellValueChanged">
      <template #header>
        <Grid gaf="column" justify-content="space-between" align-items="center">
          <div class="text-subtitle-1 text-secondary-2 q-ml-sm q-mt-sm">ADDITIONAL INVOICES</div>

          <RBtn size="small" type="text" @click="showModal = true">Create new invoice</RBtn>
        </Grid>
      </template>
    </AgGrid>
  </RCard>
</template>

<script>
import * as apiTo from '@/modular-api'
import { gridOptions } from './gridOptions'
// Libraries
import { cloneDeep, isEqual } from 'lodash'
// Components
import AgGrid from '@/ag-grid/AgGrid'
import CreateInvoiceModal from '@/reusable/CreateInvoiceModal'
import { GET_ENTITY_ADDITIONAL_INVOICES, UPDATE_ENTITY_ADDITIONAL_INVOICE } from '@/modular-api'

export default {
  components: {
    AgGrid,
    CreateInvoiceModal
  },

  mixins: [gridOptions],

  props: {
    namespace: {
      type: String,
      required: true
    }
  },

  data: () => ({
    data: null,
    showModal: false
  }),

  created() {
    this.getAndSetTableRows()
  },

  methods: {
    getAndSetTableRows() {
      apiTo
        .GET_ENTITY_ADDITIONAL_INVOICES(this.namespace, this.$route.params.id)
        .then(({ data }) => (this.data = data.result))
    },

    cellValueChanged({ newValue, column, oldValue, data }) {
      const newVal = cloneDeep(newValue) || null
      const oldVal = cloneDeep(oldValue) || null
      if (isEqual(newVal, oldVal)) return

      const updatedData = cloneDeep(data)
      updatedData.approval_date = this.formatDateForPost(updatedData.approval_date, [
        this.settings.date_format,
        'YYYY-MM-DD'
      ])
      updatedData.due_date = this.formatDateForPost(updatedData.due_date, [this.settings.date_format, 'YYYY-MM-DD'])
      updatedData.issue_date = this.formatDateForPost(updatedData.issue_date, [this.settings.date_format, 'YYYY-MM-DD'])
      updatedData.payment_date = this.formatDateForPost(updatedData.payment_date, [
        this.settings.date_format,
        'YYYY-MM-DD'
      ])

      this.updateTable(updatedData, column, oldValue)
    },

    updateTable(updatedData, column, oldValue) {
      apiTo
        .UPDATE_ENTITY_ADDITIONAL_INVOICE(this.namespace, this.$route.params.id, updatedData.id, updatedData)
        .then(({ data }) => {
          this.$refs.agGrid.updateRow(data.result.id, data.result)
        })
        .catch(() => {
          this.$refs.agGrid.updateRow(updatedData.id, {
            ...updatedData,
            [column.colId]: oldValue
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins.scss';

.additional-invoices {
  @include table-with-no-filters;
}
</style>
